import type HttpClient from "../../tastyworks/http"
import {
  parseSingleResponse,
  type SingleResponse,
} from "../../tastyworks/response"

export class PasskeyService {
  private readonly passkeysClient: HttpClient

  constructor(userMeClient: HttpClient) {
    this.passkeysClient = userMeClient.nested("passkeys")
  }

  readonly registrationBegin = async (): Promise<
    SingleResponse<PublicKeyCredentialCreationOptionsJSON>
  > => {
    const helper = await this.passkeysClient.postJson("registration", {})
    return parseSingleResponse(
      helper,
      (data) => data.toJson() as PublicKeyCredentialCreationOptionsJSON
    )
  }
}
